import { useEffect, useMemo, useState } from 'react';

import {
    Box,
    Button,
    Card,
    Checkbox,
    Collapse,
    Divider,
    Flex,
    Heading,
    Icon,
    Link,
    Menu,
    MenuButton,    
    MenuList,
    MenuItemOption,
    MenuOptionGroup,
    Tab,
    Tabs,
    TabList,
    TabPanel,
    TabPanels,
    Text,
    useBreakpointValue,
    Stack
} from '@chakra-ui/react';

import { SetupBox } from './Misc/SetupBox';

import { FaChevronDown } from "react-icons/fa";
import { FiExternalLink } from "react-icons/fi";

export function TimeslotForm({requestActive, setups, fullSchedule, usedSchedule, outputSchedule, marSchedule, teamData, schedAllowed, schedCount, scheduleOnClick}) {
    const [selectedTeamId, setSelectedTeamId] = useState("");
    const [bringingPad, setBringingPad] = useState(false);
    const [moddingPad, setModdingPad] = useState(false);
    const [dayIdx, setDayIdx] = useState(0);
    const [timeIdx, setTimeIdx] = useState(0);
    const [selectedSetupId, setSelectedSetupId] = useState(-1);
    const [selectedSlotId, setSelectedSlotId] = useState(false);

    const slotCardsJustifyContent = useBreakpointValue(
        {
          "base": ()=> "center",
          "xl": ()=>  "start"
        }
    );

    const tabSize = useBreakpointValue(
        {
          "base": ()=> "xs",
          "xl": ()=>  "sm"
        }
    );

    let currentSchedule = outputSchedule;

    if (usedSchedule === "mar") {
        currentSchedule = marSchedule;
    }

    const gameTypes = ["itg", "pump"];

    const filteredTeamData = {};
    
    Object.values(teamData).forEach((team)=>{
        if (
            (usedSchedule === "output" && team?.["RO_REGISTERED"] !== 1) ||
            (usedSchedule === "mar" && team?.["MAR_REGISTERED"] !== 1 && team?.["RO_REGISTERED"] === 1)
        ) {
            filteredTeamData[team?.["teams_id"]] = team;
        }
    });

    const teamIds = Object.keys(filteredTeamData);

    const teamName = teamData?.[selectedTeamId]?.["teams_name"];
    const teamGame = teamData?.[selectedTeamId]?.["teams_game"];

    const teamOptions = teamIds?.map((id, idx)=>
        <MenuItemOption isDisabled={requestActive} key={idx} value={id}>
            {teamData[id]["teams_name"]}
        </MenuItemOption>
    );    

    debugger;

    const currentDays = Object.keys(currentSchedule);

    const dayTabs = currentDays?.map((day, idx)=>
        <Tab isDisabled={requestActive} fontSize={tabSize} ml={1} mr={1} key={idx}>{day}</Tab>
    );

    const currentDay = currentDays[dayIdx];

    const currentTimes = Object.keys(currentSchedule[currentDay]);

    const timesTabs = currentTimes?.map((time, idx)=>
        <Tab isDisabled={requestActive} fontSize={tabSize} ml={1} mr={1} key={idx}>{time}</Tab>
    );

    const currentTime = currentTimes[timeIdx];

    let currentSlots = currentSchedule[currentDay][currentTime];

    currentSlots = currentSlots.filter((slotId)=>{
        const filterSetupId = fullSchedule?.[slotId]?.["schedule_setup_id"];
        const filterSetupDefaultGame = gameTypes[setups?.[filterSetupId]?.["setup_default_game_id"]];
        const filterSetupSwappable = setups?.[filterSetupId]?.["setup_swappable"] === 1 ? true : false;
        const filterSetupModdable = setups?.[filterSetupId]?.["setup_moddable"] === 1 ? true : false;

        return  (bringingPad && filterSetupSwappable) ||
                (
                    !bringingPad &&
                    (filterSetupDefaultGame === teamGame) &&  
                    (
                        !moddingPad ||
                        (moddingPad && filterSetupModdable) 
                    )
                );
    });

    const slotCards = currentSlots?.map((slotId, idx)=>
        <SetupBox
            requestActive={requestActive}
            setups={setups?.[fullSchedule?.[slotId]?.["schedule_setup_id"]]} 
            selectedSetup={selectedSetupId} 
            hasCheck={true}
            onChange={()=>{
                setSelectedSlotId(slotId);
                setSelectedSetupId(fullSchedule?.[slotId]?.["schedule_setup_id"]);
            }} 
            key={idx}
        />
    );

    const timesTabPanels = currentTimes?.map((time, idx)=>
        <TabPanel key={idx} pl={0} pr={0}>
            <Heading size="md">Select setup:</Heading>
            <Flex mt={3} flexDirection="row" flexFlow="wrap" justifyContent={slotCardsJustifyContent}>
                {currentSlots?.length > 0 ? slotCards : "No setups are available for you with those options on that day and time."}
            </Flex>
        </TabPanel>
    );

    const daysTabPanels = currentDays?.map((day, idx)=>
        <TabPanel key={idx} pl={0} pr={0}>
            <Heading size="md">Select time:</Heading>
            <Tabs mt={3} index={timeIdx} variant='solid-rounded' onChange={(idx)=>{changeTimeIdx(idx)}}>
                <TabList>{timesTabs}</TabList>
                <TabPanels>{timesTabPanels}</TabPanels>
            </Tabs>
        </TabPanel>
    );

    const changeTeamSelect = (id) => {
        setSelectedTeamId(id);
        setBringingPad(false);
        setModdingPad(false);
        setTimeIdx(0);
        setSelectedSetupId(-1);
    }    

    const bringingPadChecked = () => {
        setModdingPad(false);
        setBringingPad(bringingPad ? false : true);
        setSelectedSetupId(-1);
    }

    const moddingPadChecked = () => {
        setBringingPad(false);
        setModdingPad(moddingPad ? false : true);
        setSelectedSetupId(-1);
    }

    const changeDayIdx = (index) => {
        setDayIdx(index);
        setTimeIdx(0);
        setSelectedSetupId(-1);
    }

    const changeTimeIdx = (index) => {
        setTimeIdx(index);
        setSelectedSetupId(-1);
    }

    useEffect(()=> console.log("TimeslotForm mounted"), []);

    useEffect (()=> ()=> console.log("TimeslotForm unmounted"), []);

    try {
        return (
            <>
                <Heading size="md">Select team:</Heading>
                <Box mt={3}>
                    <Menu>
                        <MenuButton as={Button} rightIcon={<FaChevronDown/>}>
                            {("" + selectedTeamId)?.length > 0 ? teamName : "Choose a team..."}
                        </MenuButton>
                        <MenuList>
                            <MenuOptionGroup value={selectedTeamId} type='radio' onChange={(id)=>changeTeamSelect(id)}>
                                {teamOptions}
                            </MenuOptionGroup>
                        </MenuList>
                    </Menu>
                </Box>
                <Collapse in={("" + selectedTeamId)?.length > 0} animateOpacity unmountOnExit>           
                    <Card maxWidth="1400px" padding={5} mt={4} mb={2}>
                        <Flex flexWrap="wrap" direction="row" justifyContent="space-evenly">
                            <Box maxWidth={{base: "300px", xl: "775px"}}>
                                <Text mb={4}>
                                    Pads will be pre-modded to a reasonable degree, but not all provided pads are allowed to be modded by participants 
                                    during the event.  If modding the pads is especially important to you, check the corresponding box.
                                </Text> 
                                <Text mb={4}>
                                    If you'd like to bring your own full size arcade pad, it is allowed for certain setups, but please check 
                                    appropriate box below to filter down to the ones where swapping the pads is allowed.
                                </Text>
                                <Text>
                                    For <strong>travel/mini pads only</strong> (please check with us on 
                                    <Link color='teal.300' href={'https://staminanation.com/'} isExternal> Discord <Icon as={FiExternalLink} mx='2px' top='3px' position="relative"/></Link> 
                                    to make sure yours counts), you may bring and use the pad on <em>any</em> setup-- including the 'non-swappable' ones--
                                    provided you bring a non-slip mat to place between your pad and the surface of the setup's default pad to avoid 
                                    any damage.
                                </Text>                        
                            <Divider mt={4} mb={4} orientation='horizontal'/>
                            <Stack spacing={[1, 5]} direction={['column', 'row']}>
                                <Checkbox isDisabled={requestActive || moddingPad} size="lg" isChecked={bringingPad} onChange={()=>bringingPadChecked()}>I will bring my own pad</Checkbox>
                                <Checkbox isDisabled={requestActive || bringingPad} size="lg" isChecked={moddingPad} onChange={()=>moddingPadChecked()}>I want to mod the provided pad</Checkbox>
                            </Stack>                            
                            </Box>
                        </Flex>
                    </Card>
                    <Heading size="md">Select day:</Heading>
                    <Tabs mt={3} index={dayIdx} variant='solid-rounded' onChange={(idx)=>{changeDayIdx(idx)}}>
                        <TabList>
                            {dayTabs}                
                        </TabList>
                        <TabPanels>
                            {daysTabPanels}
                        </TabPanels>
                    </Tabs>
                    <Button 
                        isDisabled={
                            requestActive ||
                            !schedAllowed ||
                            selectedSetupId < 0
                        }
                        maxWidth="1400px" 
                        width="100%" 
                        fontSize="xl" 
                        onClick={()=>{
                            scheduleOnClick(selectedTeamId, selectedSlotId, selectedSetupId, bringingPad)
                        }}
                    >
                        Schedule Set
                    </Button>     
                </Collapse>
            </>
        );
    } catch (e) {
        console.error("TimeslotForm render error: ", e);
    }
}